import { connect } from "react-redux";




import { getJobList } from "../Jobs/jobsActions";
import { getOfficeDetails, getOfficesShortList } from "../OfficesNew/officesActions";
import { getOrganizationMembersShortList } from "../Projects/projectsActions";
import JobsInMap from "./JobsInMap";


const mapStateToProps = state => ({
  profile: state.profile,
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersShortList: state.project.orgMembersShortList,
  officesShortList: state.office.officesShortList,
  officeDetails: state.office.officeDetails,
  filters: state.filterReducer.filters,
  jobList: state.jobs.jobList,
  isLoadingJobs: state.jobs.isLoadingJobs,
});

const mapDispatchToProps = dispatch => ({
  getOfficesShortList: payload => dispatch(getOfficesShortList(payload)),
  getOfficeDetails: payload => dispatch(getOfficeDetails(payload)),
  getOrganizationMembersShortList: payload =>
    dispatch(getOrganizationMembersShortList(payload)),
  getJobList: payload => dispatch(getJobList(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobsInMap);